package ru.it_mozaika.sender.js.application.routes


import js.core.jso
import react.create
import react.router.RouteObject
import ru.it_mozaika.sender.js.application.context.TemplatesProvider
import ru.it_mozaika.sender.js.application.frames.templates.templatesListFrame


val templateRoutes = jso<RouteObject> {
    path = "templates/:type"
    element = TemplatesProvider.create{
        templatesListFrame()
    }
}
